import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	ProjectDataCategory,
	ProjectDataPointDefinition,
	ProjectDataValue,
} from '../models/projectData';

interface ProjectDataState {
	categories: ProjectDataCategory[];
	pointDefinitions: ProjectDataPointDefinition[];
	values: ProjectDataValue[];
	loading: boolean;
	initialized: boolean;
	error: string | null;
}

const initialState: ProjectDataState = {
	categories: [],
	pointDefinitions: [],
	values: [],
	loading: false,
	initialized: false,
	error: null,
};

const projectDataSlice = createSlice({
	name: 'projectData',
	initialState,
	reducers: {
		setCategories(state, action: PayloadAction<ProjectDataCategory[]>) {
			state.categories = action.payload;
			state.initialized = true;
		},
		addCategory(state, action: PayloadAction<ProjectDataCategory>) {
			state.categories.push(action.payload);
		},
		updateCategory(state, action: PayloadAction<ProjectDataCategory>) {
			const idx = state.categories.findIndex(
				(c) => c.id === action.payload.id
			);
			if (idx !== -1) state.categories[idx] = action.payload;
		},
		setPointDefinitions(
			state,
			action: PayloadAction<ProjectDataPointDefinition[]>
		) {
			state.pointDefinitions = action.payload;
		},
		addPointDefinition(
			state,
			action: PayloadAction<ProjectDataPointDefinition>
		) {
			state.pointDefinitions.push(action.payload);
		},
		updatePointDefinition(
			state,
			action: PayloadAction<ProjectDataPointDefinition>
		) {
			const idx = state.pointDefinitions.findIndex(
				(d) => d.id === action.payload.id
			);
			if (idx !== -1) state.pointDefinitions[idx] = action.payload;
		},
		setValues(state, action: PayloadAction<ProjectDataValue[]>) {
			state.values = action.payload;
		},
		addValue(state, action: PayloadAction<ProjectDataValue>) {
			state.values.push(action.payload);
		},
		updateValue(state, action: PayloadAction<ProjectDataValue>) {
			const idx = state.values.findIndex(
				(v) => v.id === action.payload.id
			);
			if (idx !== -1) state.values[idx] = action.payload;
		},
		setLoading(state, action: PayloadAction<boolean>) {
			state.loading = action.payload;
		},
		setError(state, action: PayloadAction<string | null>) {
			state.error = action.payload;
		},
	},
});

export const {
	setCategories,
	addCategory,
	updateCategory,
	setPointDefinitions,
	addPointDefinition,
	updatePointDefinition,
	setValues,
	addValue,
	updateValue,
	setLoading,
	setError,
} = projectDataSlice.actions;

export default projectDataSlice.reducer;
